import React, { useState, useEffect, useRef } from "react";
// import logo from "./../images/MAAMAAS_LOGO.png";
import "./Settings.css"
import "./Company.css";
import "./Style.css";
import Billing from "./Billing";
import Employee from "./Employee";
import Tablereservation from "./Tablereservation";
import Tablereservations from "./Tablereservations";
import Tickets from "./Tickets";
import Timings from "./Timings";
import Orders from './Orders';
import CateringAdvertisements from "./CateringAdvertisements"
import { Link } from "react-router-dom";

const Settings = () => {
  const plan = localStorage.getItem("planType") || "standard";

  const [activeTab, setActiveTab] = useState('Timings');
  const [isHovered, setIsHovered] = useState(false);
  const scrollContainerRef = useRef(null);
  const isMobile = window.innerWidth <= 768;
  const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
  const [isPaused, setIsPaused] = useState(false);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const orderPosts = [
    { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
    { dishId: 2, orderId: '12346', orderType: 'Take Away' },
    { dishId: 3, orderId: '12347', orderType: 'Delivery' },
    { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
    { dishId: 2, orderId: '12346', orderType: 'Take Away' },
    { dishId: 3, orderId: '12347', orderType: 'Delivery' },
    { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
    { dishId: 2, orderId: '12346', orderType: 'Take Away' },
    { dishId: 3, orderId: '12347', orderType: 'Delivery' },
  ];
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1; // Scroll down smoothly

          // Infinite loop logic
          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0; // Reset to top for seamless loop
          }
        }
      }, 20); // Adjust speed by changing interval
    };

    startScrolling();
    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    return () => clearInterval(interval);
  }, [isHovered]);
  const scrollRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollInterval;

    if (scrollContainer && !isPaused) {
      scrollInterval = setInterval(() => {
        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          scrollContainer.scrollTop = 0;
        } else {
          scrollContainer.scrollTop += 1; // scroll speed
        }
      }, 50);
    }

    return () => clearInterval(scrollInterval);
  }, [isPaused]); // pause state control karega


  const getOfferColor = (type) => {
    switch (type) {
      case "buffet":
        return "#ff6f61";
      case "wedding":
        return "#6a5acd";
      case "birthday":
        return "#ffb347";
      case "corporate":
        return "#2e8b57";
      default:
        return "#333";
    }
  };

  const fileInputRef = useRef(null);
  // {=======================overview===============================}
  const allTabs = {

    Timings: <Timings />,
    Employee: <Employee />,
    "Billing SetUp": <Billing />,
    Table: <Tablereservations />,
    "View Tickets": <Tickets />,
  };

  // Filter tabs by plan
  const getTabsForPlan = (plan) => {
    switch (plan.toLowerCase()) {
      case "basic":
        return ["Timings", "Billing SetUp", "View Tickets"];
      case "standard":
        return ["Timings", "Employee", "Billing SetUp", "View Tickets"];
      case "premium":
        return ["Timings", "Employee", "Billing SetUp", "Table", "View Tickets"];
      default:
        return ["Employee"];
    }
  };

  const visibleTabKeys = getTabsForPlan(plan);
  return (<>


    <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapperyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:67px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 0px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }
             

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="Col-lg-7">
          <p
            className="breadcrumb maamaas-home-bredcum"
            style={{
              position: "fixed",
              top: isMobile ? "50px" : "80px",
              left: isMobile ? "5px" : "275px",
              width: "100%",
              backgroundColor: "#fff",
              zIndex: 1000,
              padding: "10px 0",
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: isMobile ? "normal" : "bold",
              textAlign: "center",
              margin: 0,
            }}
          >
            <Link
              to="/mainladdingpage"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Home
            </Link>
            <span className="separator"> &gt; </span>
            <Link
              to="/company"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              DigitalMenuBillings
            </Link>
            <span className="separator"> &gt; </span>
            <Link
              to="/settings"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Settings
            </Link>


          </p>




          {/* Left Section */}
          <div className="left-column" style={{}}>
            <div className="tabs-wrapperyy ">

              <div className="tab-buttons" style={{}}>
                {visibleTabKeys.map((label) => (
                  <button
                    key={label}
                    className={`tab-button ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>
                ))}
              </div>
              <div className="tab-content" style={{
                overflow: 'auto', height: '500px', scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}> {allTabs[activeTab]}</div>
            </div>
          </div>


        </div>
        {activeTab !== "" && (
          <div>
            <CateringAdvertisements />
          </div>
        )}
      </div>
    </div>
  </>
  );
};



export default Settings;
